import React, { useEffect, useState,useRef } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight, ArrowRightIcon } from "lucide-react"; // Import arrow icon
import { FaPhoneAlt } from "react-icons/fa";
import { PiPhoneCallFill, PiUsersThreeFill } from "react-icons/pi";
import { MdVerified } from "react-icons/md";
import { FaCode, FaMobileAlt, FaBullhorn, FaDatabase } from "react-icons/fa";
import WebTechnology from "./WebTechnology";

const services = [
  {
    title: "Web Development",
    description:
      "Build scalable and high-performance websites tailored to your business needs.",
    icon: <FaCode size={40} className="text-white" />,
  },
  {
    title: "Android & iOS App Development",
    description:
      "Develop feature-rich mobile applications for both Android and iOS platforms.",
    icon: <FaMobileAlt size={40} className="text-white" />,
  },
  {
    title: "Digital Marketing & Business Promotions",
    description:
      "Enhance your online presence and boost your business with data-driven marketing strategies.",
    icon: <FaBullhorn size={40} className="text-white" />,
  },
  {
    title: "CRM Software",
    description:
      "Optimize customer relationships with powerful CRM solutions tailored for your business.",
    icon: <FaDatabase size={40} className="text-white" />,
  },
];
const dummy = [
  {
    image: "/mainImg.jpg",
    title: "Creative AI Based IT Solutions",
    desc: "We're a dynamic IT solutions company specializing in next-generation digital innovations. We provide cutting-edge technology solutions to help our clients thrive in today's fast-paced digital world.",
    button: (
      <Link to="/contact">
        <button className="bg-sky-400 hover:bg-sky-500 px-6 py-3 rounded-full text-lg font-semibold shadow-lg transition">
          Get Started Now
        </button>
      </Link>
    ),
  },
  {
    image: "/bgImg2.jpg",
    title: "Creative AI Based IT Solutions",
    desc: "We're a dynamic IT solutions company specializing in next-generation digital innovations. We provide cutting-edge technology solutions to help our clients thrive in today's fast-paced digital world.",
    button: (
      <Link to="/contact">
        <button className="bg-sky-400 hover:bg-sky-500 px-6 py-3 rounded-full text-lg font-semibold shadow-lg transition">
          Get Started Now
        </button>
      </Link>
    ),
  },
];

const Home = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev >= dummy.length - 1 ? 0 : prev + 1));
    }, 3000);
    return () => clearInterval(interval);
  }, [dummy.length]);


  const [currentColorIndex, setCurrentColorIndex] = useState(0);
  const colors = ["bg-purple-600", "bg-indigo-600", "bg-blue-600", "bg-pink-600"];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentColorIndex((prevIndex) => (prevIndex + 1) % colors.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);


  const leftRef = useRef(null);
  const rightRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
          }
        });
      },
      {
        threshold: 0.3, // Trigger when 30% is visible
      }
    );

    if (leftRef.current) observer.observe(leftRef.current);
    if (rightRef.current) observer.observe(rightRef.current);

    return () => {
      if (leftRef.current) observer.unobserve(leftRef.current);
      if (rightRef.current) observer.unobserve(rightRef.current);
    };
  }, []);
  return (
    <section>
      {/* HomePage........................................... */}
      <div className="relative w-full h-screen flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <img
          src={dummy[index].image}
          alt={`Background ${index + 1}`}
          className="absolute inset-0 w-full h-full object-cover"
        />

        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/70"></div>



        {/* Hero Content */}
        <div className="relative text-center text-white px-6 z-10 w-full">

         <div className="  px-9 md:px-18 lg:px-36 space-y-5">
         <p className=" text-5xl font-bold uppercase tracking-wide text-sky-400">
            {dummy[0].title}
          </p>
          <h1 className="text-xl lg:px-16 font-semibold mt-2 leading-tight">
            {dummy[0].desc}
          </h1>
         </div>

          {/* CTA Button */}
          <div className="mt-6 flex items-center justify-center gap-6">
            {dummy[index].button}
          </div>
        </div>
      </div>

      {/* About page................................. */}

      <div className="bg-gray-200 py-20 px-4 sm:px-6 md:px-12 lg:px-16">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Side - Image */}
          <div ref={leftRef} className="relative flex justify-center leftsideAnimations ">
            <div className="relative inline-block p-4 ">
              {/* <Image src={aboutImg} alt="Team Working" className="rounded-lg w-full" /> */}
              <img className="border roumded-lg" src="/aboutImg2.jpg" alt="" />
            </div>

          </div>

          {/* Right Side - Content */}
          <div ref={rightRef} className=" rightsideAnimations">
            <h5 className="text-sky-400 font-semibold text-sm uppercase mb-2">About Us</h5>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold leading-snug">
              We Are Increasing Business Success With <span className="text-sky-400">IT Solution</span>
            </h2>
            <p className="text-gray-600 mt-4 text-sm sm:text-base">
              "Seamlessly design intuitive supply chains and streamline cross-functional workflows. Efficiently develop competitive resources and foster holistic collaboration. Innovate and implement optimized strategies for future success."
            </p>

            {/* Features */}
            <div className="flex flex-wrap gap-4 sm:gap-6 mt-6">
              <div className="flex items-center gap-2 sm:gap-3">
                <MdVerified size={24} className="text-sky-400 sm:size-30" />
                <div>
                  <h4 className="font-semibold text-sm sm:text-base">Certified Company</h4>
                  <p className="text-xs sm:text-sm text-gray-600">Best Provide Skills Services</p>
                </div>
              </div>
              <div className="flex items-center gap-2 sm:gap-3">
                <PiUsersThreeFill size={24} className="text-sky-400 sm:size-30" />
                <div>
                  <h4 className="font-semibold text-sm sm:text-base">Expert Team</h4>
                  <p className="text-xs sm:text-sm text-gray-600">100% Expert Team</p>
                </div>
              </div>
            </div>

            {/* Call to Action */}
            <div className="mt-6 flex flex-wrap items-center gap-4">
              <Link onClick={() => {
              window.scroll(0, 0)
            }} to="/webTechnology">
                <button className="flex  items-center bg-sky-400 hover:bg-sky-500 px-8 py-3 rounded-full text-lg font-semibold shadow-lg transition text-white">
                  Discover More<ArrowRightIcon className="w-5 h-5 ml-2" />
                </button>
              </Link>
              <a className="flex  items-center bg-sky-400 hover:bg-sky-500 px-8 py-3 rounded-full text-lg font-semibold shadow-lg transition text-white" href="tel:+917019291371" >
                +91 70192 91371
              </a>

            </div>
          </div>
        </div>
      </div>

      {/* Web-Technology Page....................................... */}
     <div>
      <WebTechnology/>
     </div>

    </section>
  );
};

export default Home;
